module.exports = __webpack_public_path__ + "img/revive.1a492eec.svg";